// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./variables.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("illustration.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-root {
  width: 100%;
}

.navbar-container-login {
  height: 64px;
  position: relative;
}

.navbar-content-login {
  align-items: center;
  display: flex;
  height: 64px;
  padding: 0 30px;
}

.login-nav-container {
  position: absolute;
  height: 64px;
  background: none;
  align-items: center;
  display: flex;
  height: 64px;
}

.login-container {
  display: flex;
  height: 100vh; /* Full viewport height */
}

.login-form {
  flex: 1 1; /* Takes up half of the container */
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center vertically */
  align-items: center; /* Center horizontally */
  padding: 20px;
  background-color: var(--tertiary-background-color); /* Background color for the form side */
}

.login-form h1 {
  margin-bottom: 20px;
  font-size: 25px;
  color: var(--text-color); /* Adjust color as needed */
}

.login-form form {
  width: 100%;
  max-width: 400px; /* Limit the form width */
}

.login-form input {
  width: 100%;
  padding: 15px;
  margin-bottom: 20px;
  border: none;
  border-radius: 8px;
  background: #fefefe; /* Light background color for the input fields */
  color: #333; /* Dark text color */
}

.login-form button {
  width: 100%;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: #007bff; /* Adjust button color */
  color: var(--text-color);
  font-size: 1em;
  cursor: pointer;
}

.login-form button:hover {
  background-color: #0056b3; /* Darker button color on hover */
}

.login-image {
  flex: 1 1; /* Takes up half of the container */
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: cover; /* Ensure the image covers the section */
}

/* Mobile-friendly adjustments */
@media only screen and (max-width: 768px) {
  .login-nav-container {
    padding: 0px;
  }

  .login-container {
    flex-direction: column;
  }

  .login-image {
    display: none; /* Hide the image section on mobile */
  }
}

/* Error message styles */
.error-container {
  opacity: 0; /* Start with hidden */
  transition: opacity 0.5s ease-in-out; /* Smooth fade transition */
  visibility: hidden;
  margin-top: 20px;
  padding: 15px;
  color: var(--text-color);
  background-color: #d9534f; /* Red background color */
  border-radius: 8px; /* Rounded corners */
  text-align: center;
  font-size: 14px; 
  font-family: 'Montserrat', sans-serif;
  height: 35px;
}

/* Show the error container when there's an error */
.error-container.show {
  display: block; /* Show when the error class is applied */
  visibility: visible;
  opacity: 1;
}


`, "",{"version":3,"sources":["webpack://./src/Login.css"],"names":[],"mappings":"AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa,EAAE,yBAAyB;AAC1C;;AAEA;EACE,SAAO,EAAE,mCAAmC;EAC5C,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,sBAAsB;EAC/C,mBAAmB,EAAE,wBAAwB;EAC7C,aAAa;EACb,kDAAkD,EAAE,uCAAuC;AAC7F;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,wBAAwB,EAAE,2BAA2B;AACvD;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,yBAAyB;AAC7C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB,EAAE,gDAAgD;EACrE,WAAW,EAAE,oBAAoB;AACnC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB,EAAE,wBAAwB;EACnD,wBAAwB;EACxB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;AAC9D;;AAEA;EACE,SAAO,EAAE,mCAAmC;EAC5C,2EAA2D;EAC3D,sBAAsB,EAAE,wCAAwC;AAClE;;AAEA,gCAAgC;AAChC;EACE;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa,EAAE,qCAAqC;EACtD;AACF;;AAEA,yBAAyB;AACzB;EACE,UAAU,EAAE,sBAAsB;EAClC,oCAAoC,EAAE,2BAA2B;EACjE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,yBAAyB,EAAE,yBAAyB;EACpD,kBAAkB,EAAE,oBAAoB;EACxC,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE,cAAc,EAAE,yCAAyC;EACzD,mBAAmB;EACnB,UAAU;AACZ","sourcesContent":["@import './variables.css';\n\n.login-root {\n  width: 100%;\n}\n\n.navbar-container-login {\n  height: 64px;\n  position: relative;\n}\n\n.navbar-content-login {\n  align-items: center;\n  display: flex;\n  height: 64px;\n  padding: 0 30px;\n}\n\n.login-nav-container {\n  position: absolute;\n  height: 64px;\n  background: none;\n  align-items: center;\n  display: flex;\n  height: 64px;\n}\n\n.login-container {\n  display: flex;\n  height: 100vh; /* Full viewport height */\n}\n\n.login-form {\n  flex: 1; /* Takes up half of the container */\n  display: flex;\n  flex-direction: column;\n  justify-content: center; /* Center vertically */\n  align-items: center; /* Center horizontally */\n  padding: 20px;\n  background-color: var(--tertiary-background-color); /* Background color for the form side */\n}\n\n.login-form h1 {\n  margin-bottom: 20px;\n  font-size: 25px;\n  color: var(--text-color); /* Adjust color as needed */\n}\n\n.login-form form {\n  width: 100%;\n  max-width: 400px; /* Limit the form width */\n}\n\n.login-form input {\n  width: 100%;\n  padding: 15px;\n  margin-bottom: 20px;\n  border: none;\n  border-radius: 8px;\n  background: #fefefe; /* Light background color for the input fields */\n  color: #333; /* Dark text color */\n}\n\n.login-form button {\n  width: 100%;\n  padding: 15px;\n  border: none;\n  border-radius: 8px;\n  background-color: #007bff; /* Adjust button color */\n  color: var(--text-color);\n  font-size: 1em;\n  cursor: pointer;\n}\n\n.login-form button:hover {\n  background-color: #0056b3; /* Darker button color on hover */\n}\n\n.login-image {\n  flex: 1; /* Takes up half of the container */\n  background: url('illustration.png') no-repeat center center;\n  background-size: cover; /* Ensure the image covers the section */\n}\n\n/* Mobile-friendly adjustments */\n@media only screen and (max-width: 768px) {\n  .login-nav-container {\n    padding: 0px;\n  }\n\n  .login-container {\n    flex-direction: column;\n  }\n\n  .login-image {\n    display: none; /* Hide the image section on mobile */\n  }\n}\n\n/* Error message styles */\n.error-container {\n  opacity: 0; /* Start with hidden */\n  transition: opacity 0.5s ease-in-out; /* Smooth fade transition */\n  visibility: hidden;\n  margin-top: 20px;\n  padding: 15px;\n  color: var(--text-color);\n  background-color: #d9534f; /* Red background color */\n  border-radius: 8px; /* Rounded corners */\n  text-align: center;\n  font-size: 14px; \n  font-family: 'Montserrat', sans-serif;\n  height: 35px;\n}\n\n/* Show the error container when there's an error */\n.error-container.show {\n  display: block; /* Show when the error class is applied */\n  visibility: visible;\n  opacity: 1;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
